import React from 'react'
import ScrollContainer from '@components/ScrollContainer'
import Card from '@components/Card'
import CheckItem from '@components/workOrder/CheckItem'
import HorizontalLine from '@components/HorizontalLine'
import { StyleSheet, Text } from 'react-native'
import MainLayout from '@layouts/MainLayout'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.VIEW

interface PendingWorkOrderProps {
  route: {
    params: {
     workOrder: StringifiedWorkOrderRequest,
    }
  }
}

export default function ({ route }: PendingWorkOrderProps) {
  const { workOrder } = route.params

  let photos: Photo[]
  if (workOrder?.photos === undefined) photos = []
  else if (typeof workOrder?.photos === 'string') photos = JSON.parse(workOrder?.photos)
  else photos = workOrder?.photos

  const totalPhotos = photos.length

  const photosText = (lang: string) => {
    switch (lang) {
      case 'es':
        return `${totalPhotos} ${COPY.PHOTO}${totalPhotos !== 1 ? 's' : ''} ${COPY.ATTACHED}${totalPhotos !== 1 ? 's' : ''}`
      case 'de':
        return `${totalPhotos} ${COPY.PHOTO}${totalPhotos !== 1 ? 's' : ''} ${COPY.ATTACHED}`
      default:
        return `${totalPhotos} ${COPY.PHOTO}${totalPhotos !== 1 ? 's' : ''} ${COPY.ATTACHED}`
    }
  }

  return (
    <MainLayout>
      <ScrollContainer>
        <Text style={styles.header}>{COPY.PENDING_HEADER}</Text>
        <Card style={styles.descriptionContainer}>
          <Text style={styles.title}>{COPY.DESCRIPTION}</Text>
          <Text style={styles.description}>
            {workOrder?.details?.description}
          </Text>
        </Card>
        <HorizontalLine />
        <CheckItem label={COPY.URGENT} isToggled={!!workOrder?.details?.urgent} />
        <CheckItem label={COPY.AFTER_HOURS} isToggled={!!workOrder?.details?.afterHours} />
        <Card style={styles.infoItem}>
          <Text style={styles.infoItemText}>
            {photosText('en')} {/** TODO: replace by actual language variable */}
          </Text>
        </Card>
      </ScrollContainer>
    </MainLayout>
  )
}

const styles = StyleSheet.create({
  header: {
    fontSize: 22,
    fontWeight: '700',
    color: colors.gray[800],
    textAlign: 'left',
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    color: colors.gray[700],
    textAlign: 'left',
    marginBottom: 15,
  },
  descriptionContainer: {
    marginBottom: 10,
  },
  description: {
    fontSize: 16,
    fontWeight: '400',
    color: colors.gray[500],
    textAlign: 'left',
  },
  infoItem: {
    marginTop: 10,
    padding: 15,
    flexDirection: 'row',
  },
  infoItemText: {
    fontSize: 16,
    flex: 1,
  },
})
